import apiClient from './apiClient';

export const backtestAPI = {
  // Get all backtests for the current user
  getBacktests: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) {
      queryParams.append('status', params.status);
    }
    if (params.limit) {
      queryParams.append('limit', params.limit);
    }
    // Use cursor instead of lastEvaluatedKey for standardized cursor-based pagination
    if (params.cursor) {
      queryParams.append('cursor', params.cursor);
    }
    
    const url = `/backtests${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiClient.get(url);
  },

  // Get specific backtest request details
  getBacktest: (requestId) => {
    return apiClient.get(`/backtests/${requestId}`);
  },

  // Get backtest results with performance metrics (full payload: trades, curves — 1–3 MB)
  getBacktestResults: (requestId) => {
    return apiClient.get(`/backtests/${requestId}/results`);
  },

  // Headline metrics only (~2 KB): per-symbol stats plus the portfolio/aggregate blocks, bulky
  // fields stripped. What a list row needs (DWLF-306).
  getBacktestSummaryResults: (requestId) => {
    return apiClient.get(`/backtests/${requestId}/results`, { params: { summary: true } });
  },

  // Create new backtest request
  createBacktest: (backtestData) => {
    return apiClient.post('/backtests', backtestData);
  },

  // Delete backtest and its results
  deleteBacktest: (requestId) => {
    return apiClient.delete(`/backtests/${requestId}`);
  },

  // Get summary statistics
  getBacktestSummary: () => {
    return apiClient.get('/backtests/summary');
  }
};

export default backtestAPI; 